import React from 'react';
import { Container, Row, Col, } from 'react-bootstrap';
import '../../components/css/categories.css';
import {FaUniversity,FaMoneyCheck,FaComments,FaBookOpen,FaNewspaper,FaMoneyCheckAlt,FaBriefcase,FaUsers,FaChartLine,FaCreditCard,FaGavel,FaGlobe,FaPhone  } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function Categories() {
  return (
    <Container fluid className="my-5 customCon">
      <Container>
        <Row className="mb-4">
          <Col className="text-left">
            <h1>Categories </h1>
          </Col>
        </Row>
        <Row>
          <Col md={4} className="mb-4  customHover">
          <Link to="/money-skills" className="text-decoration-none text-dark d-block h-100">
          <FaBriefcase size="3rem" />
          <br></br><br></br>
            <h3>Money Skill</h3>
            <p>A brief guide to Money Skill, covering budgeting, saving, and smart money management.</p>
            </Link>
          </Col>

          <Col md={4} className="mb-4  customHover">
          <Link to="/faqs" className="text-decoration-none text-dark d-block h-100">
          <FaMoneyCheckAlt size="3rem" />
          <br></br><br></br>
            <h3>Faqs</h3>
            <p>A guide to frequently asked questions, providing clear answers and guidance on our services, accounts, and processes.</p>
            </Link>
          </Col>

          <Col md={4} className="mb-4  customHover">
          <Link to="/career" className="text-decoration-none text-dark d-block h-100">
          <FaUsers size="3rem" />
          <br></br><br></br>
            <h3>Career</h3>
            <p>A brief guide to careers, outlining available job opportunities, application process, requirements, and growth prospects.</p>
            </Link>
          </Col>
          
        </Row>
      
        <Row>
        <Col md={4} className="mb-4  customHover">
          <Link to="/ways-to-bank" className="text-decoration-none text-dark d-block h-100">
          <FaMoneyCheck size="3rem" />
          <br></br><br></br>
            <h3>Ways to Bank </h3>
            <p>A quick guide to ways to bank, covering available channels, account access, transactions, and convenient banking options.</p>
            </Link>
          </Col>

           <Col md={4} className="mb-4  customHover">
          <Link to="/press" className="text-decoration-none text-dark d-block h-100">
          <FaNewspaper size="3rem" />
          <br></br><br></br>
            <h3>Press</h3>
            <p>A brief overview of our press section, highlighting news, announcements, media coverage, and official updates.</p>
            </Link>
          </Col>

          <Col md={4} className="mb-4  customHover">
          <Link to="/about_kontriman" className="text-decoration-none text-dark d-block h-100">
          <FaUniversity size="3rem" />
          <br></br><br></br>
            <h3>About us</h3>
            <p>A concise overview of us, covering our mission, vision, values, services, and commitment to customers.</p>
            </Link>
          </Col>
        </Row>

        <Row>
        <Col md={4} className="mb-4  customHover">
          <Link to="/blog" className="text-decoration-none text-dark d-block h-100">
          <FaNewspaper size="3rem" />
          <br></br><br></br>
            <h3>Blogs </h3>
            <p>A quick guide to our blogs, featuring insights, tips, updates, and expert advice on financial topics and services.</p>
            </Link>
          </Col>

           <Col md={4} className="mb-4  customHover">
          <Link to="/our-story" className="text-decoration-none text-dark d-block h-100">
          <FaBookOpen size="3rem" />
          <br></br><br></br>
            <h3>Our Story</h3>
            <p>A brief overview of our story, highlighting our journey, mission, milestones, and commitment to serving our customers.</p>
            </Link>
          </Col>

          <Col md={4} className="mb-4  customHover">
          <Link to="/testimonies" className="text-decoration-none text-dark d-block h-100">
          <FaComments size="3rem" />
          <br></br><br></br>
            <h3>Testimonies</h3>
            <p>A quick overview of testimonies, sharing customer experiences, feedback, and success stories with our services.</p>
            </Link>
          </Col>
        </Row>
      
        <br></br>
        <Row>
          <Col md={6} className="mb-4  customHover">
          <Link to="/legal" className="text-decoration-none text-dark d-block h-100">
          <FaGavel size="3rem" />
          <br></br><br></br>
            <h3>Legal</h3>
            <p>A brief guide to our legal section, covering policies, terms, compliance, and regulatory information.</p>
            </Link>
          </Col>
  
          <Col md={6} className="mb-4 customHover">
          <Link to="/contact-us" className="text-decoration-none text-dark d-block h-100">
          <FaPhone size="3rem" />
          <br></br><br></br>
            <h3>Contact us</h3>
            <p>A quick guide to contacting us, providing ways to reach our support team, submit inquiries, and get assistance.</p>
            </Link>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Categories;
